import CreateNATSConnection from './nats';
export default CreateNATSConnection;
